export default "__VITE_ASSET__BdjlfLBM__"